import React, { useState, useEffect } from "react";
import { FaChevronLeft } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import SearchExportComponent from "../Components/Layout/SearchExportComponent";
import { getSales } from "../actions/DashboardAction";
import TableLayout from "../Components/Layout/TableLayout";
import Pagination from "../Components/Layout/Pagination";

const SalesVsProduct = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [visibleHeaders, setVisibleHeaders] = useState([
    "name",
    "sales",
    "revenue",
  ]);
  const tableHeaders = [
    { label: "Product Name", value: "name" },
    { label: "Doctor name", value: "doctorsname" },
    { label: "Products", value: "products" },
    { label: "Patient Email", value: "patientemail" },
    { label: "Group Name", value: "group_title" },
    { label: "Product Group", value: "product_group" },
    { label: "Category", value: "category" },
    { label: "UnitPrice", value: "unit_price" },
    { label: "Quantity", value: "sales" },
    { label: "Revenue", value: "sales" },
    { label: "Status", value: "tracking_status" },
    { label: "Sales Order_Status", value: "sales_order_status" },
    // { label: "Action", value: "action" },
  ];
  const fetchData = async () => {
    const response = await getSales();
    console.log("response", response);
    if (response) {
      setData(response);
      setCurrentPage(response.currentPage);
      setTotalCount(response.totalCount);
      setTotalPages(response.totalPages);
    }
  };
  useEffect(() => {
    fetchData();
  }, [currentPage]);
  const handleSearch = (term) => setSearchTerm(term);
  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };
  const handlePageChange = (page) => setCurrentPage(page);
  const handleBack = () => {
    navigate("/");
  };
  return (
    <div className="px-4">
      <div className="flex justify-start items-center gap-2">
        <button onClick={handleBack}>
          <FaChevronLeft className="text-text1 w-5 h-5" />
        </button>
        <h1 className="text-3xl font-bold text-text2">
          Sales vs Product Groups
        </h1>
      </div>
      <div className="pt-6">
        <SearchExportComponent
          onSearch={handleSearch}
          tablefields={tableHeaders}
          selectedHeaders={visibleHeaders}
          onHeadersChange={setVisibleHeaders}
          FilterOptionVisisbility={false}
          ExportOptionVisisbility={false}
          onExport={() => {}}
        />
        <TableLayout
          data={data}
          headers={tableHeaders.filter((header) =>
            visibleHeaders.includes(header.value)
          )}
        />
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalCount}
          onPageChange={handlePageChange}
          itemsPerPage={itemsPerPage}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
      </div>
    </div>
  );
};

export default SalesVsProduct;
